import { render, staticRenderFns } from "./SetCustomerNameDialog.vue?vue&type=template&id=c18e781c"
import script from "./SetCustomerNameDialog.vue?vue&type=script&lang=js"
export * from "./SetCustomerNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports